import React from "react";
import styles from "./DaysRemaining.module.css";
import ProgressBar from "../../ProgressBar/ProgressBar.module";
import NumberComponent from "../../NumberComponent";
const DaysRemaining = ({ item }) => {
  return (
    item.price !== 0 && (
      <>
        <div className={styles.remining}>
          مدت زمان باقی مانده از سرویس
          {"remainingTime" in item && item.remainingTime !== 0 ? (
            <>
              {item.remainingTime.days !== 0 ? (
                <>
                  <span className={styles.remval}>
                    {NumberComponent(item.remainingTime.days)}
                    روز
                  </span>
                </>
              ) : (
                <>
                  {item.remainingTime.hours !== 0 ? (
                    <>
                      <span className={styles.remval}>
                        {NumberComponent(item.remainingTime.hours)}
                        ساعت
                      </span>
                    </>
                  ) : (
                    <>
                      <span className={styles.remval}>
                        {NumberComponent(item.remainingTime.minutes)}
                        دقیقه
                      </span>
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
        <ProgressBar
          value={item.PercentageUsedDays}
          maxValue={100}
          color={item.PercentageUsedDays < 90 ? "rgb(9, 68, 128)" : "red"}
          thickness={20}
        />
      </>
    )
  );
};

export default DaysRemaining;
